import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addOutgoingTransportToBusiness = ({
  businessId,
  client,
  transport_distance,
  means_transportation,
  country_arrival,
  total_weight_delivery,
  subcategory,
  subcategory_description,
  price_invoice,
  invoice_date,
  invoice_number,
  manuel,
  manuel_distribution,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  const key = "add-new-outgoing-transport";
  var data = JSON.stringify({
    client: client,
    transport_distance: transport_distance,
    means_transportation: means_transportation,
    country_arrival: country_arrival,
    total_weight_delivery: total_weight_delivery,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    manuel: manuel || null,
    manuel_distribution: manuel_distribution
      ? manuel_distribution * 1000
      : null, // Convert tonnes back to kg for backend
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/outgoing-transport",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (key) {
        triggerInvalidate(key);
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteOutgoingTransport = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/outgoing-transport/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getOutgoingTransportList = ({
  businessId,
  subcategory,
  subcategory_description,
  subcategoryId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryOutgoingTransport = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/outgoing-transport",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryOutgoingTransport(
        response.data.total_obj.systemboundary_category
      );
      setObjects(
        response.data.data
          .filter(
            (data) =>
              data.subcategory === subcategory &&
              data.subcategory_description === subcategory_description &&
              (subcategoryId === null || data.subcategory_obj === subcategoryId)
          )
          .map((data) => {
            data.means_transportation = objectifyForDropdown(
              data.means_transportation
            );
            data.country_arrival = objectifyForDropdown(data.country_arrival);

            // Convert manuel_distribution from kgCO2e to tCO2e for display only
            if (
              data.manuel_distribution !== null &&
              data.manuel_distribution !== undefined
            ) {
              // Convert kg to tonnes for display
              data.manuel_distribution = data.manuel_distribution / 1000;
            }

            return data;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateOutgoingTransport = ({
  businessId,
  objectId,
  subcategoryId,
  client,
  transport_distance,
  means_transportation,
  country_arrival,
  total_weight_delivery,
  subcategory,
  subcategory_description,
  price_invoice,
  invoice_date,
  invoice_number,
  manuel,
  manuel_distribution,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    subcategory_obj: subcategoryId,
    client: client,
    transport_distance: transport_distance,
    means_transportation: means_transportation,
    country_arrival: country_arrival,
    total_weight_delivery: total_weight_delivery,
    subcategory: subcategory,
    subcategory_description: subcategory_description,
    price_invoice: price_invoice || null,
    invoice_date: invoice_date || null,
    invoice_number: invoice_number || null,
    manuel: manuel || null,
    manuel_distribution: manuel_distribution
      ? manuel_distribution * 1000
      : null, // Convert tonnes back to kg for backend
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/outgoing-transport/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            response.data.data.means_transportation = objectifyForDropdown(
              response.data.data.means_transportation
            );
            response.data.data.country_arrival = objectifyForDropdown(
              response.data.data.country_arrival
            );

            // Convert manuel_distribution from kgCO2e to tCO2e for display only
            if (
              response.data.data.manuel_distribution !== null &&
              response.data.data.manuel_distribution !== undefined
            ) {
              // Convert kg to tonnes for display
              response.data.data.manuel_distribution =
                response.data.data.manuel_distribution / 1000;
            }

            return response.data.data;
          }
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getOutgoingTransport = ({
  businessId,
  objectId,
  objects,
  setObjects,
  subcategory,
  subcategory_description,
  subcategoryId = null,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/outgoing-transport/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects
          .filter(
            (data) =>
              data.subcategory === subcategory &&
              data.subcategory_description === subcategory_description &&
              (subcategoryId === null || data.subcategory_obj === subcategoryId)
          )
          .map((supply) => {
            const gotValue = response.data.data;

            if (gotValue.id === supply.id) {
              gotValue.means_transportation = objectifyForDropdown(
                gotValue.means_transportation
              );
              gotValue.country_arrival = objectifyForDropdown(
                gotValue.country_arrival
              );
              return gotValue;
            }
            return supply;
          })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const getOutgoingTransportSubcategory = ({
  businessId,
  setCustomSubcategory = function () {
    return;
  },
  setSubcategoryNames = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/outgoing-transport-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setCustomSubcategory(response.data);
      const subNames = response.data.map((item) => {
        return item.name;
      });
      setSubcategoryNames(subNames);
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const updateOutgoingTransportSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/outgoing-transport-sub/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const createOutgoingTransportSubcategory = ({
  businessId,
  objectId,
  objects,
  subcategory,
  subcategory_description,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
  triggerInvalidate = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: subcategory,
    subcategory_description: subcategory_description,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/outgoing-transport-sub",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");
  const key = "add-new-outgoing-subcategory";

  axios(config)
    .then(function (response) {
      setErrorMessage();
      setObjects(response.data);
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const deleteOutgoingTransportSubcategory = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
  triggerInvalidate = function () {
    return;
  },
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/outgoing-transport-sub/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");
  const key = "delete-outgoing-subcategory";

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      if (key) triggerInvalidate(key);
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};
